var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7803 6.20404C12.0732 6.49694 12.0732 6.97181 11.7803 7.26471L8.06066 10.9844L11.7803 14.704C12.0732 14.9969 12.0732 15.4718 11.7803 15.7647C11.4874 16.0576 11.0126 16.0576 10.7197 15.7647L6.46967 11.5147C6.17678 11.2218 6.17678 10.7469 6.46967 10.454L10.7197 6.20404C11.0126 5.91115 11.4874 5.91115 11.7803 6.20404Z",
    fill: "#0F172A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.7db1a804ffa2205a0c5d34d5a6e86d9f.svg";
export { ForwardRef as ReactComponent };